var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 152,
    viewBox: "0 0 190 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.47,88.393C9.843,90.993 5.247,91.393 2.401,88.993C-0.445,86.593 -0.883,82.393 1.744,79.793C4.371,77.193 8.968,76.793 11.813,79.193C14.659,81.593 15.097,85.593 12.47,88.393Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.771,113.794C41.144,116.394 36.547,116.794 33.702,114.394C30.856,111.994 30.418,107.794 33.045,105.194C35.672,102.594 40.268,102.194 43.114,104.594C45.959,106.994 46.397,110.994 43.771,113.794Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.154,164.393C103.528,166.993 98.931,167.393 96.085,164.993C93.24,162.593 92.802,158.393 95.429,155.793C98.055,153.193 102.652,152.793 105.498,155.193C108.562,157.593 108.781,161.793 106.154,164.393Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.237,189.794C134.611,192.394 130.014,192.794 127.168,190.394C124.323,187.994 123.885,183.794 126.512,181.194C129.138,178.594 133.735,178.194 136.581,180.594C139.645,182.994 139.864,187.194 137.237,189.794Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.943,87.794C66.317,90.394 61.72,90.794 58.874,88.394C56.029,85.994 55.591,81.794 58.218,79.194C60.845,76.594 65.441,76.194 68.287,78.594C71.351,80.994 71.57,85.194 68.943,87.794Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.026,113.194C97.4,115.794 92.803,116.194 89.957,113.794C87.112,111.394 86.674,107.194 89.301,104.594C91.927,101.994 96.524,101.594 99.37,103.994C102.434,106.394 102.653,110.594 100.026,113.194Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.327,138.594C128.701,141.194 124.104,141.593 121.258,139.193C118.413,136.793 117.975,132.594 120.602,129.994C123.228,127.394 127.825,126.993 130.671,129.393C133.735,131.793 133.954,135.794 131.327,138.594Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.114,61.994C91.488,64.594 86.891,64.994 84.046,62.594C81.2,60.194 80.762,55.994 83.389,53.394C86.016,50.794 90.612,50.394 93.458,52.794C96.522,55.194 96.741,59.194 94.114,61.994Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.197,87.394C122.571,89.994 117.974,90.394 115.128,87.994C112.283,85.594 111.845,81.394 114.472,78.794C117.098,76.194 121.695,75.794 124.541,78.194C127.386,80.594 127.824,84.594 125.197,87.394Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.498,112.594C153.872,115.194 149.275,115.593 146.429,113.193C143.584,110.793 143.146,106.594 145.773,103.994C148.399,101.394 152.996,100.993 155.842,103.393C158.906,105.793 159.125,109.994 156.498,112.594Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.799,137.994C185.172,140.594 180.576,140.994 177.73,138.594C174.885,136.194 174.447,131.994 177.074,129.394C179.7,126.794 184.297,126.394 187.142,128.794C189.988,131.194 190.426,135.394 187.799,137.994Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.986,10.794C85.36,13.394 80.763,13.794 77.918,11.394C75.072,8.994 74.634,4.794 77.261,2.194C79.887,-0.406 84.484,-0.806 87.33,1.594C90.394,3.994 90.613,7.994 87.986,10.794Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.588,61.393C147.961,63.993 143.365,64.393 140.519,61.993C137.674,59.593 137.236,55.393 139.863,52.793C142.489,50.193 147.086,49.793 149.932,52.193C152.777,54.593 153.215,58.793 150.588,61.393Z",
    fill: "#113670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.671,86.794C179.044,89.394 174.448,89.794 171.602,87.394C168.757,84.994 168.319,80.794 170.946,78.194C173.572,75.594 178.169,75.194 181.014,77.594C184.079,79.994 184.298,84.194 181.671,86.794Z",
    fill: "#113670"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img-2.0cdc8a6927c01717683f402f1fb937c6.svg";
export { ForwardRef as ReactComponent };